import React from 'react';
import { FileText, Video, Image, Music, File } from 'lucide-react';

interface FileIconProps {
  type: string;
  size?: number;
}

const FileIcon: React.FC<FileIconProps> = ({ type, size = 32 }) => {
  const iconProps = { size };
  
  switch (type.toLowerCase()) {
    case 'pdf':
      return <FileText {...iconProps} color="#ef4444" />;
    case 'video':
    case 'mp4':
    case 'avi':
    case 'mov':
      return <Video {...iconProps} color="#3b82f6" />;
    case 'image':
    case 'jpg':
    case 'png':
    case 'gif':
      return <Image {...iconProps} color="#10b981" />;
    case 'audio':
    case 'mp3':
    case 'wav':
      return <Music {...iconProps} color="#8b5cf6" />;
    default:
      return <File {...iconProps} color="#6b7280" />;
  }
};

export default FileIcon;